import Debug from 'debug'
import RESTResource from '../rest/RESTResource.js'
import protectedSymbol from '../util/protected.js'

const debug = Debug('cbio.User')

export default class User extends RESTResource {
  constructor (api, resource = {}) {
    super(api, resource)
    debug('constructed User')
  }

  static url (state = {}) {
    return `/api/1/users/${state.id || ''}`
  }

  #field = (key) => {
    return this[protectedSymbol].field(key)
  }

  toJSON = () => {
    return {
      id: this.id
    }
  }
}
